import React from 'react'
import DatePicker from "react-datepicker";
import customRequest from '../../../helpers/customRequest'
import getURLParams from '../../../helpers/getURLParams'
import redirect from '../../../components/redirect/redirect'
import message from '../../../components/message/message'
import { initializeFormValidation } from '../../../helpers/forms/form-validation'
import ClipLoader from 'react-spinners/ClipLoader'
import moment from 'moment';

class Edit extends React.Component
{
    state = {
        loading: true,
        submitting: false,
        selectedDate: moment().toDate()
    }
    componentDidMount() {
        let params = getURLParams()
        customRequest.get('/api/students/edit', {
            params: {
                name: params.student,
                customerUsername: params.customer ?? ""
            }
        })
        .then(({ data }) => {

            if (data.valid == false) {
                redirect.send("/students")
                console.error(data)
                return message.error("There has been an error editing your student. Please try again.")
            }
            document.getElementById("student-name").value = data.name || document.getElementById("student-name").value
            document.getElementById('gender').value = data.gender || document.getElementById("gender").value
            document.getElementById('ethnicity').value = data.ethnicity || document.getElementById("ethnicity").value
            document.getElementById('enrollment').value = data.enrollment || document.getElementById("enrollment").value
            document.getElementById('iep').value = data.iep || document.getElementById("iep").value
            document.getElementById('retention').value = data.retention || document.getElementById("retention").value
            document.getElementById('english-language-learner').value = data.englishLangauageLearner || document.getElementById("english-language-learner").value
            this.setState({
                loading: false,
                selectedDate: moment(`${data.birthYear}-${data.birthMonth}-${data.birthDay}`, 'YYYY-M-D').toDate()
            })
        })

        initializeFormValidation(this.onSubmit);
    }

    onSubmit = () => {
        this.setState({loading: true, submitting: true }, () => 
        {
            let params = getURLParams()
            customRequest.post('/api/students/edit', {
                previousName: params.student,
                name: document.getElementById('student-name').value,
                birthDay: this.state.selectedDate.getDate(),
                birthMonth: this.state.selectedDate.getMonth() + 1,
                birthYear: this.state.selectedDate.getFullYear(),
                gender: document.getElementById('gender').value,
                ethnicity: document.getElementById('ethnicity').value,
                enrollment: document.getElementById('enrollment').value,
                iep: document.getElementById('iep').value,
                retention: document.getElementById('retention').value,
                englishLanguageLearner: document.getElementById('english-language-learner').value,
                customerUsername: params.customer ?? ""
            })
            .then(({data}) => {
                this.setState({loading: false, submitting: false })
                message.clear()
                if (data.valid) {
                    redirect.send("/students")
                    message.success("Your student's information has been successfully edited.")
                } else {
                    message.error(data.message)
                }
            })
        })
    }

    render()
    {
        return (
            <React.Fragment>
                <h1>Edit Student Information</h1>
                <form class = "form-horizontal form-validate" noValidate method = "post">
                    <div class = "form-group row">
                        <label for = "student-name" class = "d-none d-sm-inline col-sm-3 control-label text-right">Name</label>
                        
                        <div class = "col-sm-6">
                            <div class = "input-group">
                                <input type = "text" class = "form-control unique" disabled={this.state.loading} id = "student-name" name = "name"  placeholder = "Name" required data-description = "enter your student's name" autofocus />
                                
                                <span class = "input-group-text">First and Last</span>
                            </div>
                        </div>
                    </div>
                    
                    <div class = "form-group row">
                        <label for = "student-birthday" class = "d-none d-sm-inline col-sm-3 control-label text-right">Birthday</label>
                        <div class = "col-sm-6">
                            <div class = "input-group">
                                <DatePicker
                                    id="student-birthday" 
                                    className = "form-control unique" 
                                    selected={this.state.selectedDate} 
                                    onSelect={(newDate)=>{
                                        this.setState({
                                            selectedDate: newDate
                                        })
                                    }} 
                                    showMonthDropdown
                                    showYearDropdown
                                />
                            </div>
                        </div>
                    </div>
                    
                    <div class = "form-group row">
                        <label for = "gender" class = "d-none d-sm-inline col-sm-3 control-label text-right">Gender (optional)</label>
                        
                        <div class = "col-sm-6">
                            <select class = "form-control" disabled={this.state.submitting} id = "gender" name = "gender">
                                <option value = "">Gender:</option>
                                <option value = "Male">Male</option>
                                <option value = "Female">Female</option>
                                <option value = "Other">Other</option>
                                <option value = "Decline to Answer">Decline to Answer</option>
                            </select>
                        </div>
                    </div>

                    <div class = "form-group row">
                        <label for = "ethnicity" class = "d-none d-sm-inline col-sm-3 control-label text-right">Ethnicity (optional)</label>
                        
                        <div class = "col-sm-6">
                            <select class = "form-control" disabled={this.state.submitting} id = "ethnicity" name = "ethnicity">
                                <option value = "">Ethnicity:</option>
                                <option value = "White">White</option>
                                <option value = "Hispanic Origin">Hispanic Origin</option>
                                <option value = "Mideastern/Arab Descent">Mideastern/Arab Descent</option>
                                <option value = "Black">Black</option>
                                <option value = "Asian/Pacific Islander">Asian/Pacific Islander</option>
                                <option value = "South Asian">South Asian</option>
                                <option value = "American Indian/Alaskan Native">American Indian/Alaskan Native</option>
                                <option value = "Multi-Racial">Multi-Racial</option>
                                <option value = "Decline to Answer">Decline to Answer</option>
                            </select>
                        </div>
                    </div>
                    
                    <div class = "form-group row">
                        <label for = "enrollment" class = "d-none d-sm-inline col-sm-3 control-label text-right">Current School Enrollment (optional)</label>
                        
                        <div class = "col-sm-6">
                            <select class = "form-control" disabled={this.state.submitting} id = "enrollment" name = "enrollment">
                                <option value = "">Enrollment:</option>
                                <option value = "Public">Public</option>
                                <option value = "Private">Private</option>
                                <option value = "Cyber">Cyber</option>
                                <option value = "Homeschooling">Homeschooling</option>
                                <option value = "Not Applicable">Not Applicable</option>
                                <option value = "Decline to Answer">Decline to Answer</option>
                            </select>
                        </div>
                    </div>

                    <div class = "form-group row">
                        <label for = "iep" class = "d-none d-sm-inline col-sm-3 control-label text-right">IEP related to reading (optional)</label>
                        
                        <div class = "col-sm-6">
                            <select class = "form-control" disabled={this.state.submitting} id = "iep" name = "iep">
                                <option value = "">IEP:</option>
                                <option value = "Yes">Yes</option>
                                <option value = "No">No</option>
                                <option value = "Decline to Answer">Decline to Answer</option>
                            </select>
                        </div>
                    </div>

                    <div class = "form-group row">
                        <label for = "retention" class = "d-none d-sm-inline col-sm-3 control-label text-right">Retention (optional)</label>
                        
                        <div class = "col-sm-6">
                            <select class = "form-control" disabled={this.state.submitting} id = "retention" name = "retention">
                                <option value = "">Retention:</option>
                                <option value = "Never Retained">Never Retained</option>
                                <option value = "Retained 1 Year">Retained 1 Year</option>
                                <option value = "Retained 2 Year">Retained 2 Year</option>
                                <option value = "Retained 3 Year">Retained 3 Year</option>
                                <option value = "Decline to Answer">Decline to Answer</option>
                            </select>
                        </div>
                    </div>

                    <div class = "form-group row">
                        <label for = "english-language-learner" class = "d-none d-sm-inline col-sm-3 control-label text-right">English Language Learner (optional)</label>
                        
                        <div class = "col-sm-6">
                            <select class = "form-control" disabled={this.state.submitting} id = "english-language-learner" name = "english-language-learner">
                                <option value = "">English Language Learner:</option>
                                <option value = "Yes">Yes</option>
                                <option value = "No">No</option>
                                <option value = "Decline to Answer">Decline to Answer</option>
                            </select>
                        </div>
                    </div>

                    <button type = "submit" class = "btn btn-secondary btn-lg" disabled={this.state.loading}>{this.state.submitting ?
                    <ClipLoader
							size={20}
							color={"#123abc"}
							loading={this.state.submitting}
							/> : "Edit"}</button>
                </form>
            </React.Fragment>
        )
    }
}

export default Edit
